<template>
  <v-col
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg">
    <v-textarea
      v-model="texto"
      v-bind="$attrs"
      filled
      :rounded="!hasError"
      :outlined="hasError"
      hide-details
      class="my-input custom-label-color"
      color="#6A83B5"
      background-color="#F2F6FF"
      v-on="$listeners"
      @update:error="errorChange"
      @blur="validateError">
      <template v-slot:label>
        <strong :class="hasError ? '' : 'custom-input-label-color'">
          {{ $attrs.label }}
        </strong>
      </template>
    </v-textarea>
  </v-col>
</template>

<script>
export default {
  name: 'CustomTextArea',
  inheritAttrs: false,
  props: {
    value: {
      default() {
        return this.value || null;
      },
    },
    cols: {
      type: String,
      default: '12',
    },
    sm: {
      type: String,
      default() {
        return this.sm || this.cols;
      },
    },
    md: {
      type: String,
      default() {
        return this.md || this.sm;
      },
    },
    lg: {
      type: String,
      default() {
        return this.lg || this.md;
      },
    },
  },
  data() {
    return {
      hasError: false,
    };
  },
  methods: {
    validateError({ srcElement }) {
      let clases = '';
      srcElement.labels.forEach((element) => {
        clases += element.className;
      });
      this.hasError = clases.toLowerCase().indexOf('error') !== -1;
    },
    errorChange(event) {
      this.hasError = event;
    },
  },
  computed: {
    texto: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">
.my-input.v-input .v-input__slot {
  border-radius: 10px;
}
.custom-label-color .v-label {
  color: red;
  opacity: 1;
}
.custom-label-color .v-text-field__prefix {
  color: #6A83B5;
  font-weight: 500 !important;
}
.custom-label-color .v-text-field__suffix {
  color: #6A83B5;
  font-weight: 500 !important;
}
.custom-label-color input{
  color: #1B1BAF !important;
  font-weight: 500 !important;
}
.custom-input-label-color {
  color: #6A83B5 !important;
}
.v-label .v-label--active .theme--light {
  color: #1B1BAF !important;
}
.greyIcon.v-input__append-inner i {
  color: #6A83B5 !important;
}
// .v-text-field__slot input {
//   color: #1B1BAF !important;
// }
// .v-text-field--outlined fieldset {
//   border-color: #F2F6FF !important;
// }
// .v-text-field--outlined fieldset :focus {
//   border-color: #1642a8 !important;
// }
</style>
